const _env = process.env;

export const NODE_ENV = _env.NODE_ENV;

export const BASE_URL = _env.BASE_URL;

export const AUTH = {
  AUTHORITY: _env.VUE_APP_URL_AUTH,
  CLIENT_ID: _env.VUE_APP_CLIENT_ID,
  POST_LOGOUT_REDIRECT_URI: _env.VUE_APP_URL_AUTH_POST_LOGOUT_REDIRECT_URI,
  POST_LOGOUT_REDIRECT_URI_TEST:
    _env.VUE_APP_URL_AUTH_POST_LOGOUT_REDIRECT_URI_TEST,
  REDIRECT_URI: _env.VUE_APP_REDIRECT_URI,
  RESPONSE_TYPE: _env.VUE_APP_RESPONSE_TYPE,
  SCOPE: _env.VUE_APP_SCOPE,
  SILENT_REDIRECT_URI:
    _env.VUE_APP_URL_AUTH_POST_LOGOUT_REDIRECT_URI + 'silent.html',
  ACR_VALUES: _env.VUE_APP_ACR_VALUES,
};

export const API = {
  BASE_URL: _env.VUE_APP_URL_API,
  BASE_URL_TEST: _env.VUE_APP_URL_API_TEST,
  TIMEOUT: 300000,
};

export const DETICKET_API = {
  BASE_URL: _env.VUE_APP_DETICKET_URL,
  TIMEOUT: 300000,
};

export const SIGNATURE_API = {
  BASE_URL: _env.VUE_APP_SIGNATURE_URL,
  TIMEOUT: 120000,
};

export const ACR_URL_LOGOUT = _env.VUE_APP_ACR_URL_LOGOUT;
export const ACR_VALUES = _env.VUE_APP_ACR_VALUES;
export const DEFAULT_PAGE_SIZE = _env.VUE_APP_DEFAULT_PAGE_SIZE;
export const SESSION_TIMEOUT = _env.VUE_APP_SESSION_TIMEOUT;
export const USER_MENU_APP_SESSION_KEY = `user-menu-${_env.VUE_APP_CLIENT_ID}`;
export const DASHBOARD_URL = _env.VUE_APP_DASHBOARD_URL;
export const SECURITY_URL = _env.VUE_APP_SECURITY_URL;
export const SIGNATURE_USER = _env.VUE_APP_SIGNATURE_USER;
export const SIGNATURE_PASSWORD = _env.VUE_APP_SIGNATURE_PASSWORD;
export const SIGNATURE_PROJECT_ID = _env.VUE_APP_SIGNATURE_PROJECT_ID;
export const IP_API_URL =
  _env.VUE_APP_IP_API_URL ?? 'https://api.ipify.org?format=json';
